import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Chip from '@material-ui/core/Chip';
import PupilFab from './PupilFab';
import store from '../../store/index';
import { setData } from '../../actions/index';
import { appColours, getDefaultViewForPupil } from '../../helpers';

const colours = appColours();
const styles = theme => ({
  card: {
    marginBottom: 16,
    cursor: 'pointer',
  },
  chipWrapper: {
    height: 24,
  },
  chip: {
    margin: 8,
    fontSize: 12,
    backgroundColor: '#9e9e9e',
    color: '#fff',
    cursor: 'pointer',
  },
  chipDanger: {
    backgroundColor: '#f44336',
    color: '#fff',
  },
  chipWarning: {
    backgroundColor: '#ffb300',
    color: '#fff',
  },
  padding: {
    padding: 16,
  },
  pupilFirstName: {
    fontSize: 18,
    color: '#394f5a',
    fontWeight: 'bold',
  },
  pupilLastName: {
    fontSize: 14,
    color: '#797979',
  },
  pupilSchoolName: {
    fontSize: 14,
    marginTop: 8,
    color: '#797979',
  },
  pupilSchoolLogo: {
    marginLeft: 'auto',
    marginRight: 0,
    maxWidth: 56,
    maxHeight: 56,
  },
  pupilCardParagraphPadding: {
    padding: '4px 16px',
  },
  pupilCardPupilDisabled: {
    padding: 20,
  },
});

class PupilCard extends React.Component {
  constructor(props) {
    super(props);

    this.onClickPupilCard = this.onClickPupilCard.bind(this);
  }

  onClickPupilCard(event, selectedPupil, defaultView = '_first_available') {
    event.stopPropagation();

    if (defaultView === '_first_available') {
      defaultView = getDefaultViewForPupil(selectedPupil);
    }

    selectedPupil.defaultView = defaultView;
    store.dispatch(setData(selectedPupil, 'selectedPupil'));
  }

  render() {
    const {
      classes, t, pupil, colourIndex,
    } = this.props;

    return (
      <div className="pupil-card">
        <Paper
          elevation={1}
          key={pupil.id}
          className={classes.card}
          onClick={event => this.onClickPupilCard(event, pupil)}
        >
          <Grid container justify="space-between" className={classes.padding}>
            <Grid item>
              <Grid container>
                <Grid item style={{ marginRight: 20 }}>
                  <PupilFab
                    initial={pupil.first_name[0]}
                    backgroundColor={colours[colourIndex][0]}
                    backgroundColorHover={colours[colourIndex][1]}
                  />
                </Grid>
                <Grid item>
                  <Typography
                    variant="h5"
                    component="h5"
                    className={classes.pupilFirstName}
                  >
                    {pupil.first_name}
                  </Typography>
                  <Typography
                    variant="h6"
                    component="h6"
                    className={classes.pupilLastName}
                  >
                    {pupil.last_name}
                  </Typography>
                  <Typography
                    variant="h6"
                    component="h6"
                    className={classes.pupilSchoolName}
                  >
                    {pupil.school_name}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              {pupil.school_logo && (
                <img
                  alt={t('Logo')}
                  src={pupil.school_logo}
                  className={classes.pupilSchoolLogo}
                />
              )}
            </Grid>
          </Grid>
          <Divider />
          {pupil.is_disabled && (
            <div className={classes.pupilCardPupilDisabled}>
              <span>{t('School has disabled parent accounts')}</span>
            </div>
          )}
          {!pupil.is_disabled && (
            <div>
              {pupil.display_homework && (
                <div
                  className={classes.pupilCardParagraphPadding}
                  onClick={event => this.onClickPupilCard(event, pupil, 'homework')
                  }
                >
                  <span>
                    {t('Homework')}
                    <span>:</span>
                  </span>
                  <Chip
                    label={`${t('To-do')} (${pupil.homework_todo_count})`}
                    className={`${classes.chip}`}
                    classes={{ root: classes.chipWrapper }}
                  />
                  <Chip
                    label={`${t('Late')} (${pupil.homework_late_count})`}
                    className={`${classes.chip} ${classes.chipDanger}`}
                    classes={{ root: classes.chipWrapper }}
                  />
                </div>
              )}
              {(pupil.display_detentions || pupil.display_activity_detentions ) && (
                  <div
                      className={classes.pupilCardParagraphPadding}
                      onClick={pupil.display_detentions  ?  event => this.onClickPupilCard(event, pupil, 'detentions') : null
                      }
                  >
                  <span>
                    {pupil.detention_alias_plural_uc}
                    <span>:</span>
                  </span>
                  <Chip
                    label={
                      `${t('Pending')} (${pupil.detention_pending_count})`
                    }
                    className={`${classes.chip} ${classes.chipWarning}`}
                    classes={{ root: classes.chipWrapper }}
                  />
                  <Chip
                    label={
                      `${t('Not attended')} (${pupil.detention_no_count})`
                    }
                    className={`${classes.chip} ${classes.chipDanger}`}
                    classes={{ root: classes.chipWrapper }}
                  />
                </div>
              )}
              {pupil.announcements_count > 0 && (
                <div
                  className={classes.pupilCardParagraphPadding}
                  onClick={event => this.onClickPupilCard(event, pupil, 'announcements')
                  }
                >
                  <span>
                    {t('Announcements')}
                    <span>:</span>
                  </span>
                  <Chip
                    label={pupil.announcements_count}
                    className={`${classes.chip} ${classes.chipDanger}`}
                    classes={{ root: classes.chipWrapper }}
                  />
                </div>
              )}
            </div>
          )}
        </Paper>
      </div>
    );
  }
}

export default withStyles(styles)(withTranslation()(PupilCard));
